import React from "react";
import PostHeader from "./PostHeader";
import ReactionBar from "./ReactionBar";
import {
  POST_TYPE,
  anniversaryLine,
  celebrationHeading,
  celebrationKindLabel,
  initials,
} from "./constants";

const CELEB_BADGE_CLASS =
  "inline-flex items-center rounded px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider bg-purple-50 text-purple-700";

const CelebrationCard = ({ post, onReacted }) => (
  <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
    <PostHeader
      post={post}
      badgeClass={CELEB_BADGE_CLASS}
      badgeLabel={celebrationKindLabel(post.type)}
      title={celebrationKindLabel(post.type)}
      avatarText={post.type === POST_TYPE.BIRTHDAY ? "\u{1F382}" : "\u{1F389}"}
    />

    <div className="px-4 pb-1 pt-3">
      <div className="flex flex-col items-center gap-2 rounded-lg bg-purple-50 px-4 py-6 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full border-2 border-green-500 bg-white text-lg font-semibold text-gray-700">
          {initials(post.employeeName)}
        </span>
        <p className="text-sm font-semibold text-purple-700">
          {celebrationHeading(post.type)}
        </p>
        <p className="text-lg font-bold text-gray-800">{post.employeeName}</p>
        {/* anniversaryYears of 0 is a first-year colleague, so this renders;
            only a birthday's null is skipped. */}
        {post.anniversaryYears != null && (
          <p className="text-xs text-gray-500">
            {anniversaryLine(post.anniversaryYears)}
          </p>
        )}
      </div>
    </div>

    <ReactionBar post={post} onReacted={onReacted} />
  </div>
);

export default CelebrationCard;
